<template>
  <section class="body-container split-viewport">
    <div class="viewport viewport-left">
      <view-room-details-title></view-room-details-title>

      <slot name="artwork"></slot>

      <view-room-details-quick-details></view-room-details-quick-details>

      <view-room-details-expand-contract v-if="('T' === $store.getters.currentRoomWingCode)"
                                         ref="renovations"
                                         title="Tuscany Tower Renovations"
                                         class="expand_contract--container-renovations">
        <div class="body-container tab">
          <img src="/library/images/view-room-details/tuscany-tower-renovation.jpg" width="700" height="200"
               alt="Tuscany Tower Renovations"/>
          <p>In our commitment to offering the most luxurious and innovative hospitality experiences, we are excited to
            announce a transformation of our Tuscany Tower suites. During this renovation, we are dedicated to minimizing
            any impact on your stay. We sincerely apologize for any inconvenience this project may cause and appreciate
            your understanding as we elevate your future visits to new heights.</p>
        </div>
      </view-room-details-expand-contract>

      <view-room-details-expand-contract title="Room Description"
                                         class="expand_contract--container-room_description">
        <slot name="roomDescription"></slot>
      </view-room-details-expand-contract>

      <view-room-details-expand-contract title="Services &amp; Amenities"
                                         class="expand_contract--container-room_amenities">
        <slot name="roomAmenities"></slot>
      </view-room-details-expand-contract>

      <view-room-details-expand-contract isSimilarRooms
                                         title="Similar Rooms"
                                         class="expand_contract--container-similar_rooms">
      </view-room-details-expand-contract>

    </div>
    <div class="viewport viewport-right">
      <view-room-details-table ref="table"
                               v-bind:preferred-rate-difference="preferredRateDifference"></view-room-details-table>
      <view-room-details-travel-agent-form></view-room-details-travel-agent-form>
      <view-room-details-preferred-onboard-form v-bind:preferred-rate-difference="preferredRateDifference"
                                                v-on:checkpreferred="checkIfUserIsLoggedIntoPreferred"></view-room-details-preferred-onboard-form>

      <div class="view_room_details--renovations_cta"
           v-if="('T' === $store.getters.currentRoomWingCode)"
           @click.stop.prevent="openRenovations">
        <h3><span class="mobile-hidden">Tuscany Tower</span> Renovations</h3>
      </div>

      <view-room-details-book-button
        v-on:update:showSimilarRooms="$store.commit('updateState', ['showSimilarRooms', $event])"
        v-on:update:similarRoomTowerOmit="$store.commit('updateState', ['similarRoomTowerOmit', $event])"
        v-bind:reservation-total="currentTotalNonPreferred" v-bind:preferredSavings="preferredRateDifference"
        v-bind:showing-preferred-offer="$store.getters.showingPreferredOffer"></view-room-details-book-button>
    </div>

    <peppermill-dialog v-if="$store.getters.currentRoomType && $store.getters.currentRoomType.DISPLAY"
                       :active="$store.state.isVariantDialogVisible" title="Room Options" is-alert
                       @close="$store.commit('updateState', ['isVariantDialogVisible', false])"
                       @cancel="$store.commit('updateState', ['isVariantDialogVisible', false])"
                       @submit="$store.commit('updateState', ['isVariantDialogVisible', false])">
      <template #body>
        <p><strong>{{ $store.getters.currentRoomTypeTitleData?.ROOM_TITLE || '' }}</strong> has multiple options, choose
          one:</p>

        <p v-for="roomTypeVariant in $store.state.roomData" :key="roomTypeVariant.PRT_ID"
           v-if="roomTypeVariant.DISPLAY">
          <a class="btn room_variant--button" href="#"
             :class="{'btn-highlight': roomTypeVariant.PRT_ID === $store.getters.currentRoomType?.PRT_ID, 'room_variant--button-icon': roomTypeVariant.DISPLAY.ROOM_SMOKING || roomTypeVariant.DISPLAY.ROOM_NON_SMOKING || roomTypeVariant.DISPLAY.ROOM_ADA}"
             @click.prevent="handleVariantSelection(roomTypeVariant, getRoomVariantTitle(roomTypeVariant))"
             :title="'Click to book ' + getRoomVariantTitle(roomTypeVariant) + 'room'">
            <span v-if="roomTypeVariant.DISPLAY.ROOM_SMOKING"
                  class="icon room_icon--container room_icon--container-smoking" aria-hidden="true"></span>
            <span v-else-if="roomTypeVariant.DISPLAY.ROOM_NON_SMOKING"
                  class="icon room_icon--container room_icon--container-non_smoking" aria-hidden="true"></span>
            <span v-else-if="roomTypeVariant.DISPLAY.ROOM_ADA"
                  class="icon room_icon--container room_icon--container-ada" aria-hidden="true"></span>

            {{ getRoomVariantTitle(roomTypeVariant) }}

            <span v-if="!$store.getters.isOnlyShowAvailability" class="room_variant--price_difference">{{ getRoomVariantPriceDifference(roomTypeVariant) }}</span>
          </a>
        </p>
      </template>
    </peppermill-dialog>
  </section>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2019-2025, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2019-08-09
 *			- Initial Install.
 *		2020-06-25
 *			- Updated to use Vue.js.
 *		2020-07-21
 *			- Fixed bug with updating room_page_id when a currentPrtId is changed..
 *		2020-08-03
 *			- Requests to the ResNet API on SUGAR now go to port 44390 for Zend PHP 7.
 *			- Added new callbacks for when inventory is not available with different calls to action.
 *				- If tower is overbooked, suggest like rooms in other towers
 *				- If date is blocked out, suggest different dates
 *				- If single room type is no longer available, show similar rooms
 *		2020-09-29
 *			- Added bug fixes for IE 11 -- yes the date on this entry is correct...
 *
 *		2021-05-19 (zsahs)
 *			- Added titles to several button links.  (Accessibility tune up).
 *
 *		2021-06-22 (jhoward)
 *			- Fix bug with _ga booking link parameter not being added.
 *
 *		2022-01-25 (jhoward)
 *			- Send tracking pixel if page view is due to metasearch click.
 *
 *		2022-06-23 (jhoward)
 *			- Fix preferred data mutations in Vuex for <view-room-details-container> component.
 *
 *		2022-08-11 (jhoward)
 *			- Update component names for imports in <view-room-details-container>.
 *			- <view-room-details-container> now initializes check in/out dates in Vuex store when mounted.
 *
 *		2023-07-13 (jhoward)
 *			- <view-room-details-container> sets both UA and GA4 linkers.
 *
 *		2024-06-10 (jhoward)
 *			- Implement Typescript in <view-room-details-container>.
 *
 *		2024-06-12 (jhoward)
 *			- Refactor room variant dialog to use <peppermill-dialog> component in <view-room-details-container>.
 *
 *		2025-01-24 (jhoward)
 *			- Restyle room variant options for room variant dialog in <view-room-details-container>.
 *			- Add the bed type and count to room variant options for room variant dialog in <view-room-details-container>.
 *			- Display room variant option rate differences for room variant dialog in <view-room-details-container>.
 *
 *		2025-02-12 (jhoward)
 *			- Change renovation message in <view-room-details-container>.
*/

import {mapState, mapGetters} from 'vuex';
import ViewRoomDetailsBookButton from "./book-button.vue";
import ViewRoomDetailsExpandContract from "./expand-contract.vue";
import ViewRoomDetailsPreferredOnboardForm from "./preferred-onboard-form.vue";
import ViewRoomDetailsQuickDetails from "./quick-details.vue";
import ViewRoomDetailsTable from "./table.vue";
import ViewRoomDetailsTitle from "./title.vue";
import ViewRoomDetailsTravelAgentForm from "./travel-agent-form.vue";
import {
  HotelBookingLinkData,
  HotelFilterWidgetSelections,
  ViewRoomDetailsExpandContractComponent, ViewRoomDetailsHotelRoomData, ViewRoomDetailsRoomDisplayData,
  ViewRoomDetailsTableComponent
} from "../hotel/defs";
import {ComponentPublicInstance, defineComponent, PropType} from 'vue';
import PeppermillDialog from "../peppermill/PeppermillDialog.vue";

export interface ViewRoomDetailsContainerComponent extends ComponentPublicInstance {
  openCalendar: (forceRefresh?: boolean, forceOpen?: boolean) => void;
}

export default defineComponent({
  name: "view-room-details-container",
  components: {
    PeppermillDialog,
    ViewRoomDetailsBookButton,
    ViewRoomDetailsExpandContract,
    ViewRoomDetailsPreferredOnboardForm,
    ViewRoomDetailsQuickDetails,
    ViewRoomDetailsTable,
    ViewRoomDetailsTitle,
    ViewRoomDetailsTravelAgentForm,
  },
  props: {
    initialRoomData: {
      type: Array as PropType<ViewRoomDetailsHotelRoomData[]>,
      default: () => []
    },
    initialBookingLinkData: {
      type: Object as PropType<HotelBookingLinkData>,
      default: () => {
      }
    },
    initialDefaultDisplayData: {
      type: Object as PropType<ViewRoomDetailsRoomDisplayData>,
      default: () => {
      }
    },
    initialPrtId: {
      type: Number,
      default: 0
    },
    preferredOfferCode: {
      type: String,
      default: 'PREFERRED'
    }
  },
  mounted() {
    //hydrate Vuex store
    this.$store.commit('updateState', ['roomData', this.initialRoomData]);
    this.$store.commit('updateState', ['bookingLinkData', this.initialBookingLinkData]);
    this.$store.dispatch('updateCheckInDate', this.initialBookingLinkData.start);
    this.$store.dispatch('updateCheckOutDate', this.initialBookingLinkData.end);
    this.$store.commit('updateState', ['defaultDisplayData', this.initialDefaultDisplayData]);
    this.$store.commit('updateState', ['preferredOfferCode', this.preferredOfferCode]);
    // this.$store.commit('updateState', ['currentPrtId', this.initialPrtId]);
    this.$store.commit('currentPrtId', this.initialPrtId);

    $(() => {
      if (this.$store.state.roomData.length === 0) {
        this.$store.commit('updateState', ['bookingDisabled', true]);
        this.openCalendar(true, true);
        window.ajaxLinkRegisterCallback(
          'SHOW-SIMILAR-ROOMS',
          () => {
            this.$store.commit('updateState', ['showSimilarRooms', true]);
          }
        );
        window.showOverlayDialog({
          alertMode: false,
          confirmAccept: 'VIEW SIMILAR',
          confirmDeny: 'OK',
          confirmTitle: 'Room Unavailable',
          confirmBody: 'This room type is no longer available.</p><p>If your plans allow, try different dates for your stay. Otherwise, you can view similar rooms that are currently available.',
          callback: 'SHOW-SIMILAR-ROOMS'
        }, this.$el as HTMLDivElement);
        window.pepTracking.event('View Room Details', 'Room No Longer Available (Pageload)', 'prt_id: ' + (this.$store.state.bookingLinkData.prt_id || 0), 0, true);
      } else {

        //look at available data to determine which room type variant should be shown initially
        this.updateCurrentRoomTypeBasedOnFilters();

        //start preferred process
        this.checkIfUserIsLoggedIntoPreferred();

        //initialize booking link
        this.updateBookingLink();

        this.updateTooltips();

        //need to request resort fee data for the current offer
        //this.updateUITaxAndFeeData(/*this.$store.state.bookingLinkData.offerCode, this.$store.state.bookingLinkData.start, this.$store.state.bookingLinkData.end*/);

        //setup hashchange event handler to close dialogs if needed
        window.addEventListener('hashchange', this.hashChangeHandler, {passive: true});

        //listen for state changes in history
        window.addEventListener('popstate', this.handlePopState);
      }

      //setup slideshows
      this.setupSlideshow();

      //send tracking pixel for metasearch if needed
      this.sendDSPixel();
    });
  },
  data() {
    return {};
  },
  watch: {
    '$store.state.resortFeeSubtotal'() {
      this.updateTooltips();
    },
    '$store.state.useResortFee'() {
      this.updateTooltips();
    },
    '$store.state.currentPrtId'() {
      const currentRoomType = this.$store.getters.currentRoomType;
      window.pepConsole.group('$store.state.currentPrtId');
      if (currentRoomType) {
        window.pepConsole.log('currentRoomType', JSON.parse(JSON.stringify(currentRoomType)));
        //update booking link data
        let bookingLinkDataTmp = this.$store.state.bookingLinkData;
        bookingLinkDataTmp.roomNum = currentRoomType.DATA[0].rrcd_sequence_number || 0;
        bookingLinkDataTmp.perferredRoomNum = currentRoomType.DATA[0].preferred_sequence_number || 0;
        bookingLinkDataTmp.prt_id = currentRoomType.PRT_ID;
        bookingLinkDataTmp.extraData.auto_book_prt = currentRoomType.PRT_ID;
        bookingLinkDataTmp.room_page_id = currentRoomType.PAGE_ID;
        bookingLinkDataTmp.extraData.room_page_id = currentRoomType.PAGE_ID;
        this.$store.commit('updateState', ['bookingLinkData', bookingLinkDataTmp]);

        //update resort fee info
        if ('DISPLAY' in currentRoomType) {
          this.$store.commit('updateState', ['resortFeeSubtotal', parseFloat(currentRoomType.DISPLAY.RESORT_FEE_SUBTOTAL)]);
          this.$store.commit('updateState', ['resortFeeTax', parseFloat(currentRoomType.DISPLAY.RESORT_FEE_TAX)]);
          this.$store.commit('updateState', ['useResortFee', !!currentRoomType.DISPLAY.USE_RESORT_FEE]);
        } else {
          this.$store.commit('updateState', ['resortFeeSubtotal', 0]);
          this.$store.commit('updateState', ['resortFeeTax', 0]);
          this.$store.commit('updateState', ['useResortFee', true])
        }
      }

      //this.updateUIForPreferred();
      this.setShowPreferredOnboardingForm();

      this.updateTotals();

      this.checkIfUserIsLoggedIntoPreferred();

      window.pepConsole.groupEnd();
    },
    bookingLinkData: {
      handler: function () {
        this.updateBookingLink();
        this.setShowPreferredOnboardingForm();
        //this.updateUITaxAndFeeData();
        this.updateTotals();
      },
      deep: true
    },
    roomData: {
      handler: function () {
        this.updateBookingLink();
        this.setShowPreferredOnboardingForm();
        //this.updateUITaxAndFeeData();
        this.updateTotals();
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      'currentPrtId',
      'roomData',
      'bookingLinkData',
      'isDevEnvironment',

      'currentTotal',

      'resortFeeSubtotal',
      'useResortFee',
      'resortFeeTax',

      'metaClick',

      'allowedOfferCodesForPreferred',
      'preferredUserIsLoggedIn',
      'showPreferredOnboardingForm'
    ]),
    ...mapGetters([
      'currentRoomType',
      'currentRoomWingCode',
      'showingPreferredOffer',
      'currentRoomTypeTitleData',
    ]),

    preferredRateDifference() {

      // window.pepConsole.group('preferredRateDifference()');

      let output = '';
      const currentRoomType = this.$store.getters.currentRoomType;

      // window.pepConsole.log('currentRoomType', currentRoomType);

      if (currentRoomType && 'DISPLAY' in currentRoomType) {

        // window.pepConsole.log('preferred subtotal', currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]);
        // window.pepConsole.log('preferred allowed offers', this.$store.state.allowedOfferCodesForPreferred);
        // window.pepConsole.log('current offer', this.$store.state.bookingLinkData.offerCode);
        // window.pepConsole.log('offer valid', this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode));

        if (currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults] > 0 && -1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode)) {

          // window.pepConsole.log('default offer', (parseFloat(currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults])));
          // window.pepConsole.log('preferred offer', (parseFloat(currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults])));
          // window.pepConsole.log('calculated savings', (parseFloat(currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults])) - (parseFloat(currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults])));

          //set rate difference
          output = '$' + window.pepHelperFunctions.formatAsDollarAmount((parseFloat(currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults])) - (parseFloat(currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults])), false);
        }
      }
      // window.pepConsole.groupEnd();

      return output;
    },


    currentTotalNonPreferred() {
      const currentRoomType = this.$store.getters.currentRoomType;
      if (currentRoomType && 'DISPLAY' in currentRoomType) {
        let total = parseFloat(currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]);
        if ('STATE_TAX_RATE' in currentRoomType.DISPLAY) {
          total += (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]);
        }
        if ('TOURISM_SURCHARGE' in currentRoomType.DISPLAY) {
          total += parseFloat(currentRoomType.DISPLAY.TOURISM_SURCHARGE);
        }
        if (this.$store.state.useResortFee) {
          if (this.$store.state.resortFeeSubtotal > 0 && this.$store.state.resortFeeTax > 0) {
            total += this.$store.state.resortFeeSubtotal;
            total += this.$store.state.resortFeeTax;
            return '$' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
          }
        } else {
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
        }
      }
      return '(calculating)';
    }
  },
  methods: {
    sendDSPixel() {
      window.pepConsole.log('sendDSPixel', window.pepHelperFunctions.getCookie('metasearch_click'));
      if (window.pepHelperFunctions.getCookie('metasearch_click') === 'YES') {
        this.$store.commit('updateState', ['metaClick', true]);
        //send pixel
        window._bparams = {
          pixel_id: '10126',
          account_id: 'peppermill',
          event_type: 'rate_selection',
          is_landing_page: 'TRUE',
          hotel_id: '54908',
          check_in_date: this.$store.state.bookingLinkData.start,
          check_out_date: this.$store.state.bookingLinkData.end,
          stay_length: this.$store.state.bookingLinkData.stayLength || window.pepDateFunctions.daysBetween(this.$store.state.bookingLinkData.start, this.$store.state.bookingLinkData.end),
          total_guests: this.$store.state.bookingLinkData.adults + this.$store.state.bookingLinkData.children,
          adults: this.$store.state.bookingLinkData.adults,
          children: this.$store.state.bookingLinkData.children,
          rooms: 1,
          price_currency: 'USD'
        };
        const scriptNode = document.createElement('script');
        scriptNode.type = 'text/javascript';
        scriptNode.async = true;
        scriptNode.src = 'https://linkcenterus.derbysoftsec.com/pixel/v1/pixel.js?v=' + Math.round(new Date().getTime() / 1000);
        const s = document.querySelector('script');
        s?.parentNode?.insertBefore(scriptNode, s);

        //delete cookies
        const cookieSettings = JSON.parse(document.querySelector('html')?.dataset?.cookie || '{}');
        window.pepHelperFunctions.deleteCookie('metasearch_click', cookieSettings.b || '/');
        window.pepHelperFunctions.deleteCookie('metasearch_page_id', cookieSettings.b || '/');
      }
    },

    updateTotals() {
      window.pepConsole.group('updateTotals');
      const currentRoomType: ViewRoomDetailsHotelRoomData | false = this.$store.getters.currentRoomType;
      window.pepConsole.log('currentRoomType', JSON.parse(JSON.stringify(currentRoomType)));
      this.$store.commit('updateState', ['currentSubtotal', this.formatSubtotal(currentRoomType)]);
      this.$store.commit('updateState', ['currentStateTax', this.formatStateTax(currentRoomType)]);
      this.$store.commit('updateState', ['currentTax', this.formatTax(currentRoomType)]);
      this.$store.commit('updateState', ['currentTourismSurcharge', this.formatTourismSurcharge(currentRoomType)]);
      this.$store.commit('updateState', ['currentResortFee', this.formatResortFee()]);
      this.$store.commit('updateState', ['currentResortFeeTax', this.formatResortFeeTax()]);
      this.$store.commit('updateState', ['currentTotal', this.formatTotal(currentRoomType)]);
      window.pepConsole.groupEnd();
    },
    formatSubtotal(currentRoomType: ViewRoomDetailsHotelRoomData | false): string {
      if (currentRoomType) {
        const numberOfAdults: 1 | 2 | 3 | 4 = this.$store.state.bookingLinkData.adults || 2;
        if (-1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults]) {
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults], false);
        } else if ('SUBTOTAL' in currentRoomType.DISPLAY) {
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DISPLAY.SUBTOTAL[numberOfAdults], false);
        }
      }

      return '(calculating)';
    },
    formatStateTax(currentRoomType: ViewRoomDetailsHotelRoomData | false): string {
      let output = '(calculating)';
      if (currentRoomType && 'DISPLAY' in currentRoomType && 'STATE_TAX_RATE' in currentRoomType.DISPLAY) {
        const numberOfAdults: 1 | 2 | 3 | 4 = this.$store.state.bookingLinkData.adults || 2;
        if (-1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults]) {
          output = '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults] * currentRoomType.DISPLAY.STATE_TAX_RATE, false);
        } else if ('STATE_TAX_RATE' in currentRoomType.DISPLAY) {
          output = '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[numberOfAdults], false);
        }

      }
      return output;
    },
    formatTax(currentRoomType: ViewRoomDetailsHotelRoomData | false): string {
      if (currentRoomType && 'DISPLAY' in currentRoomType) {
        let total = 0;
        if ('STATE_TAX_RATE' in currentRoomType.DISPLAY) {
          const numberOfAdults: 1 | 2 | 3 | 4 = this.$store.state.bookingLinkData.adults || 2;
          if (-1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults]) {
            total = currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults];
          } else {
            total = currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[numberOfAdults];
          }
        }

        if (this.$store.state.useResortFee) {
          if (this.$store.state.resortFeeSubtotal > 0 && this.$store.state.resortFeeTax > 0) {
            total += parseFloat(currentRoomType.DISPLAY.TOURISM_SURCHARGE);
            total += this.$store.state.resortFeeSubtotal;
            total += this.$store.state.resortFeeTax;
            return '' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
          }
        } else {
          total += parseFloat(currentRoomType.DISPLAY.TOURISM_SURCHARGE);
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
        }
      }
      return '(calculating)';
    },
    formatTourismSurcharge(currentRoomType: ViewRoomDetailsHotelRoomData | false): string {
      if (currentRoomType && 'DISPLAY' in currentRoomType && 'TOURISM_SURCHARGE' in currentRoomType.DISPLAY) {
        return '$' + currentRoomType.DISPLAY.TOURISM_SURCHARGE;
      }
      return '(calculating)';
    },
    formatResortFee(): string {
      if (this.$store.state.useResortFee) {
        if (this.$store.state.resortFeeSubtotal > 0) {
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(this.$store.state.resortFeeSubtotal, false);
        }
      } else {
        return 'Waived';
      }
      return '(calculating)';
    },
    formatResortFeeTax(): string {
      if (this.$store.state.useResortFee) {
        if (this.$store.state.resortFeeTax > 0) {
          return '$' + window.pepHelperFunctions.formatAsDollarAmount(this.$store.state.resortFeeTax, false);
        }
      } else {
        return 'Waived';
      }
      return '(calculating)';
    },
    formatTotal(currentRoomType: ViewRoomDetailsHotelRoomData | false): string {
      let output = '(calculating)';
      if (currentRoomType && 'DISPLAY' in currentRoomType) {
        let total = 0;
        if ('STATE_TAX_RATE' in currentRoomType.DISPLAY) {
          const numberOfAdults: 1 | 2 | 3 | 4 = this.$store.state.bookingLinkData.adults || 2;
          if (-1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults]) {
            total = currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults] + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[numberOfAdults]);
          } else {
            total = currentRoomType.DISPLAY.SUBTOTAL[numberOfAdults] + (currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[numberOfAdults]);
          }
        }

        if ('TOURISM_SURCHARGE' in currentRoomType.DISPLAY) {
          total += parseFloat(currentRoomType.DISPLAY.TOURISM_SURCHARGE);
        }
        if (this.$store.state.useResortFee) {
          if (this.$store.state.resortFeeSubtotal > 0 && this.$store.state.resortFeeTax > 0) {
            total += this.$store.state.resortFeeSubtotal;
            total += this.$store.state.resortFeeTax;
            output = '$' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
          }
        } else {
          output = '$' + window.pepHelperFunctions.formatAsDollarAmount(total, false);
        }
      }
      return output;
    },


    openCalendar(forceRefresh = false, forceOpen = false) {
      (this.$refs.table as ViewRoomDetailsTableComponent).openCalendar({}, forceRefresh, forceOpen);
    },

    handleVariantSelection(roomTypeVariant: ViewRoomDetailsHotelRoomData, variant: string) {
      this.$store.commit('currentPrtId', roomTypeVariant.PRT_ID);

      window.pepNotify.show(10000, 'You have chosen a ' + variant + ' room.');

      const currentVariantSubtotal: number = parseFloat(this.$store.getters.currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]);
      //@ts-ignore
      const subtotalDifference = (0 !== currentVariantSubtotal && currentVariantSubtotal !== roomTypeVariant.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults])
        //@ts-ignore
        ? roomTypeVariant.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults] - currentVariantSubtotal
        : 0;

      if (0 !== subtotalDifference) {
        let subtotalMsg = 'Your newly selected room option has a subtotal difference.</p>';

        if (subtotalDifference < 0) {
          subtotalMsg += '<p>Your subtotal will be $' + window.pepHelperFunctions.formatAsDollarAmount(subtotalDifference * -1, false) + ' less!';
        } else {
          subtotalMsg += '<p>Your subtotal will be $' + window.pepHelperFunctions.formatAsDollarAmount(subtotalDifference, false) + ' more.';
        }

        window.showOverlayDialog({
          alertMode: true,
          confirmAccept: 'OK',
          confirmTitle: 'Subtotal Difference',
          confirmBody: subtotalMsg
        }, this.$el as HTMLDivElement);
        window.pepTracking.event('View Room Details', 'Show subtotal difference', 'prt_ids: ' + this.$store.state.currentPrtId + '/' + roomTypeVariant.PRT_ID, 0, true);
      }

      this.$store.commit('updateState', ['isVariantDialogVisible', false]);
    },


    updateBookingLink(callbackSuccess?: () => {}) {

      clearTimeout(this.$store.state.bookingLinkUpdateTimer);

      this.$store.commit('updateState', ['bookingLinkUpdateTimer', setTimeout(() => {
        let requestData = this.$store.state.bookingLinkData;

        if (!requestData) return;

        requestData.ACTION = 'GET_RESNET_URL';
        requestData.LINK_TYPE = 'REDIRECT';

        if (this.$store.state.isDevEnvironment) {
          requestData.test = 1;
        }

        $.ajax({
          url: '/library/api/resnet.php',
          type: 'post',
          dataType: 'json',
          data: requestData,
          success: (response) => {
            if (response.STATUS === 'SUCCESS') {

              //add Google Analytics linker parameters to the URL
              response.DATA.RESNET_URL += '&_ga=' + window.pepTracking.getGALinkerParam();
              response.DATA.RESNET_URL += '&_gl=' + window.pepTracking.getGA4LinkerParam();

              this.$store.state.bookingLink = response.DATA.RESNET_URL;

              if ('history' in window && 'replaceState' in history) {
                history.replaceState(
                  {
                    roomData: this.$store.state.roomData,
                    bookingLinkData: this.$store.state.bookingLinkData,
                    defaultDisplayData: this.$store.state.defaultDisplayData,
                    currentPrtId: this.$store.state.currentPrtId
                  },
                  document.title || 'View Room Details',
                  this.$store.state.bookingLink.replace('/choose-a-room/', '/view-room-details/')
                );
              }
            }
          },
          error(jqXHR, textStatus, errorThrown) {
            //log this error
            const extraText = (typeof errorThrown === 'string')
              ? ' -- ' + errorThrown
              : '';
            window.pepTracking.event('JS Error', 'Booking Link Update', textStatus + extraText, 0, true);

            $.ajax({
              url: '/library/api/capture-js-error.php',
              dataType: 'json',
              type: 'post',
              data: {
                je_message: 'Booking Link Update',
                je_source: 'https://www.peppermillreno.com/library/js/view-room-details.min.js',
                je_lineno: 0,
                je_colno: 0,
                je_url: window.location.href,
                je_stack: "Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
              }
            });
          }
        });
      }, 250)]);
    },


    checkIfUserIsLoggedIntoPreferred() {
      //check if user is logged into preferred club
      if (window.peppermillPreferred.checkForPeppermillPreferredLoginToken()) {
        //user is logged in, let's check their token
        const tokenData = window.peppermillPreferred.getPeppermillPreferredLoginData();
        if (false === tokenData) {
          //invalid token
          this.$store.commit('updateState', ['preferredUserIsLoggedIn', false]);
          this.setShowPreferredOnboardingForm();
        } else {

          //user has login data, let's validate it on the server
          window.peppermillPreferred.getPeppermillPreferredClientID(tokenData.DATA.TOKEN, (clientCode: string) => {
            //valid token
            this.$store.commit('updateState', ['preferredUserIsLoggedIn', true]);

            if (0 < this.$store.getters.currentPreferredSubtotal) {
              //update offer code and sequence number for booking link
              this.$store.commit('updateOfferCode', this.$store.state.preferredOfferCode);
              this.$store.commit('updateRoomSequenceNumber', this.$store.getters.currentPreferredRoomSequenceNumber);
            }
            //add the client code to the booking link data
            this.$store.commit('updateLmsReference', clientCode);
            this.$store.state.bookingLinkData.lmsref = clientCode;
            this.setShowPreferredOnboardingForm();

          }, (errorMsg: string) => {

            //invalid token
            this.$store.commit('updateState', ['preferredUserIsLoggedIn', false]);
            this.setShowPreferredOnboardingForm();

          });
        }
      } else {
        this.$store.commit('updateState', ['preferredUserIsLoggedIn', false]);
        this.setShowPreferredOnboardingForm();
      }
    },


    updateTooltips() {
      const totalResortFeeCopy = (this.$store.state.resortFeeSubtotal === 0)
        ? ''
        : 'Includes resort fee and tax.<br />';
      const resortFeeCopy = (this.$store.getters.currentRoomType)
        ? ((!this.$store.state.useResortFee)
          ? 'Waived'
          : '$' + this.$store.getters.currentRoomType.DISPLAY.RESORT_FEE_BASE + ' per night.')
        : '';

      this.$store.commit('updateState', ['tooltipResortFee', resortFeeCopy]);
      this.$store.commit('updateState', ['tooltipTotal', 'Includes room rate and taxes.<br />' + totalResortFeeCopy + 'Includes tourism surcharge.']);
    },
    // updateUITaxAndFeeData(/*offerCode, startDate, endDate*/) {
    //
    //
    // },


    setShowPreferredOnboardingForm() {
      if (!this.$store.state.preferredUserIsLoggedIn) {
        const currentRoomType = this.$store.getters.currentRoomType;
        if (currentRoomType && 'DISPLAY' in currentRoomType && currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults] > 0 && -1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode)) {
          this.$store.commit('updateState', ['showPreferredOnboardingForm', true]);
          return;
        }
      }
      this.$store.commit('updateState', ['showPreferredOnboardingForm', false]);
    },
    checkIfRoomTypeVariantExists(dataKey: string, dataValue: string | number | boolean, omitPrtId = 0, valueModifierFunction = (val: string | number | boolean) => val): number | false {
      for (let i = 0, l = this.$store.state.roomData.length; i < l; i++) {
        if (this.$store.state.roomData[i].PRT_ID !== omitPrtId && dataKey in this.$store.state.roomData[i].DISPLAY && dataValue === valueModifierFunction(this.$store.state.roomData[i].DISPLAY[dataKey])) {
          return this.$store.state.roomData[i].PRT_ID;
        }
      }
      return false;
    },
    updateCurrentRoomTypeBasedOnFilters() {
      //look for filters saved to determine which of the available room types should be used as the default
      let hotelFilterCache: {
        DATA: HotelFilterWidgetSelections
      } | null = window.pepHelperFunctions.getCachedData('hotel-filter-widget-selections', 1800000) || null;

      if (hotelFilterCache?.DATA?.filters) {

        const filters = hotelFilterCache.DATA.filters;
        let filterRoomTypeFound = false;

        //check for ADA then non-smoking and then smoking
        /*if (-1 !== filters.only_show.indexOf('ADA')) {

          //look for an ADA room type variant
          var adaRoomTypePrtId = this.checkIfRoomTypeVariantExists('ROOM_ADA', true, this.$store.state.currentPrtId);

          if (false !== adaRoomTypePrtId) {
            this.$store.state.currentPrtId = adaRoomTypePrtId;
          }

        } else*/
        if (filters.accessibility) {

          //check if this room tpe has any of the selected accessibility variants
          // let accessibilityVariantFound = false;
          for (let i = 0, l = filters.accessibility.length; i < l; i++) {
            let variantPrtId = this.checkIfRoomTypeVariantExists('ROOM_ADA_VARIANT', filters.accessibility[i], 0, function (val) {
              if ('string' === typeof val) {
                return val.toUpperCase().replace(/[\s\-]/g, '_');
              }
              return val;
            });
            if (false !== variantPrtId) {
              filterRoomTypeFound = true;
              this.$store.commit('currentPrtId', variantPrtId);
              break;
            }
          }

        }

        if (!filterRoomTypeFound && filters.smoking) {
          if (-1 !== filters.smoking.indexOf('NO')) {

            //look for a non-smoking room type variant
            let nonSmokingRoomTypePrtId = this.checkIfRoomTypeVariantExists('ROOM_NON_SMOKING', true, this.$store.state.currentPrtId);

            if (false !== nonSmokingRoomTypePrtId) {
              this.$store.commit('currentPrtId', nonSmokingRoomTypePrtId);
            }

          } else if (-1 !== filters.smoking.indexOf('YES')) {

            //look for a smoking room type variant
            let smokingRoomTypePrtId = this.checkIfRoomTypeVariantExists('ROOM_SMOKING', true, this.$store.state.currentPrtId);

            if (false !== smokingRoomTypePrtId) {
              this.$store.commit('currentPrtId', smokingRoomTypePrtId);
            }
          }
        }
      }
    },
    hashChangeHandler() {
      const theHash = location.hash.replace('#', '');
      if ('reset' === theHash || '' === theHash) {
        const dialogNodes = document.querySelectorAll('body > .dialog.confirm');
        if (dialogNodes) {
          for (let i = 0, l = dialogNodes.length; i < l; i++) {
            const roomVariantBtnNode = dialogNodes[i].querySelector('.btn-room-variant');
            if (roomVariantBtnNode) {
              dialogNodes[i].dispatchEvent(new Event('close'));
              document.querySelector('html')?.classList.remove('show-overlay');
            }
          }
        }
      }
    },
    setupSlideshow() {
      if (!('pepSlideshow' in window)) return;

      const artworkNode = this.$el.querySelector('.artwork');
      if (artworkNode) {
        if (!('allSlideshows' in window)) {
          window.allSlideshows = [];
        }

        const slideshow = $.extend(true, {}, window.pepSlideshow);

        slideshow.setupSlideshow($(artworkNode), (window.allSlideshows?.length || 0) + 1);

        window.allSlideshows?.push(slideshow);
      }
    },
    handlePopState(event: PopStateEvent) {
      if ('state' in event && event.state && 'roomData' in event.state && 'bookingLinkData' in event.state && 'defaultDisplayData' in event.state && 'currentPrtId' in event.state) {
        this.$store.state.roomData = event.state.roomData;
        this.$store.state.bookingLinkData = event.state.bookingLinkData;
        this.$store.state.defaultDisplayData = event.state.defaultDisplayData;
        this.$store.state.currentPrtId = event.state.currentPrtId;
      }
    },
    openRenovations() {
      (this.$refs.renovations as ViewRoomDetailsExpandContractComponent).isExpanded = true;

      const expandContract = document.querySelector('.expand_contract--container-renovations');

      if (expandContract) {
        let scroll = window.scrollY + expandContract.getBoundingClientRect().top;
        const header = document.querySelector('#header');
        if (header) {
          scroll -= header.clientHeight;
        }
        window.scrollTo({
          top: scroll,
          behavior: 'smooth'
        });
      }
    },
    getRoomVariantTitle(roomTypeVariant: ViewRoomDetailsHotelRoomData): string {
      const variants: string[] = [];
      if (roomTypeVariant.DISPLAY.ROOM_BED_VARIANT.length) {
        variants.push(roomTypeVariant.DISPLAY.ROOM_BED_VARIANT);
      }
      if (roomTypeVariant.DISPLAY.ROOM_ADA_VARIANT.length) {
        variants.push(roomTypeVariant.DISPLAY.ROOM_ADA_VARIANT);
      }
      if (roomTypeVariant.DISPLAY.ROOM_NON_SMOKING) {
        variants.push('Non-smoking');
      } else {
        variants.push('Smoking');
      }
      return variants.join(', ');
    },
    getRoomVariantPriceDifference(roomTypeVariant: ViewRoomDetailsHotelRoomData): string {
      const currentRoomTypePrice = parseFloat(this.$store.state.currentTotal.replace(/[^\d.]/g, ''));
      const roomTypeVariantPrice = parseFloat(this.formatTotal(roomTypeVariant).replace(/[^\d.]/g, ''));
      if (roomTypeVariant.PRT_ID === this.$store.getters.currentRoomType?.PRT_ID) {
        return '(Current Selection)';
      } else if (currentRoomTypePrice && roomTypeVariantPrice) {
        const priceDifference = roomTypeVariantPrice - currentRoomTypePrice;
        if (priceDifference === 0 || priceDifference === 0.0) {
          return '(Same Price)';
        }
        return '($' + window.pepHelperFunctions.formatAsDollarAmount(Math.abs(priceDifference), true) + (priceDifference < 0 ? ' less' : ' more') + ')';
      }


      return '';
    },
  }
})
</script>

<style>
.view_room_details--renovations_cta {
  position: relative;
  height: 75px;
  background-image: url('/library/images/view-room-details/tuscany-tower-renovation.jpg');
  background-position: 50% 50%;
  background-size: cover;

  cursor: pointer;
}

.view_room_details--renovations_cta h3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  line-height: 75px;
  vertical-align: middle;
  text-align: center;
  color: #000000;
  /*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.87);*/
  background: rgba(238, 238, 238, 0.54);
}

.room_variant--price_difference {
  white-space: nowrap;
  font-size: 0.5em;
}
</style>